import React from 'react';

const TONE_CLASS = {
  default: '',
  success: 'ads-stat-card--success',
  warning: 'ads-stat-card--warning',
  danger: 'ads-stat-card--danger',
  info: 'ads-stat-card--info',
};

export const StatCard = ({ label, value, icon, tone = 'default', className = '' }) => (
  <div className={['ads-stat-card', TONE_CLASS[tone] || '', className].filter(Boolean).join(' ')}>
    {icon ? <div className="ads-stat-card__icon">{icon}</div> : null}
    <div className="ads-stat-card__value ads-type-numeral">{value}</div>
    {label ? <div className="ads-stat-card__label ads-type-caption">{label}</div> : null}
  </div>
);

export const StatCardRow = ({ children, className = '' }) => (
  <div className={['ads-stat-card-row', className].filter(Boolean).join(' ')}>{children}</div>
);

export default StatCardRow;
